export default __webpack_public_path__ + "static/pull_station_w.3f6209d35e918de880c6073fdf58559e.svg";